module.exports = __webpack_public_path__ + "img/yzm3.d91c55b5.png";